/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/naming-convention */
/**
 * TypeScript types for the Proposal Detail feature
 */
export const getRichContentResourcesByType = (resources, type) => {
    return resources.filter((resource) => resource.type === type);
};
export const mapEntryToApiRequest = (entry) => ({
    id: entry.id,
    body: entry.body,
    resource_id: entry.resourceId
});
